import type { HolidayEventType } from './holidays';

export interface HolidayPill {
  label: string;
  emoji: string;
  members: readonly HolidayEventType[];
  detail?: string;
}

// Mockup 2's fixed order (THE-746 decision 6), deliberately NOT date-sorted.
export const HOLIDAY_PILLS: readonly HolidayPill[] = [
  { label: 'New Year’s', emoji: '🎆', members: ['new_years'] },
  { label: 'MLK Day', emoji: '✊', members: ['mlk_day'] },
  { label: 'Lunar New Year', emoji: '🧧', members: ['lunar_new_year'] },
  { label: 'Valentine’s Day', emoji: '💘', members: ['valentines_day'] },
  { label: 'Presidents’ Day', emoji: '🏛️', members: ['presidents_day'] },
  { label: 'Women’s Day', emoji: '🌸', members: ['womens_day'] },
  { label: 'Eid al-Fitr & al-Adha', emoji: '🌙', members: ['eid_al_fitr', 'eid_al_adha'] },
  { label: 'St. Patrick’s Day', emoji: '☘️', members: ['st_patricks'] },
  { label: 'Holi & Diwali', emoji: '🪔', members: ['holi', 'diwali'] },
  { label: 'Jewish holidays', emoji: '🕎', members: ['purim', 'passover', 'rosh_hashanah', 'hanukkah'], detail: 'Purim · Passover · Rosh Hashanah · Hanukkah' },
  { label: 'Easter & Christmas', emoji: '🐣', members: ['easter', 'christmas'] },
  { label: 'Teacher Appreciation', emoji: '🍎', members: ['teacher_appreciation'] },
  { label: 'Mother’s Day', emoji: '💐', members: ['mothers_day'] },
  { label: 'Father’s Day', emoji: '👔', members: ['fathers_day'] },
  { label: '4th of July', emoji: '🇺🇸', members: ['fourth_of_july'] },
  { label: 'Friendship Day', emoji: '🤝', members: ['friendship_day'] },
  { label: 'Grandparents Day', emoji: '👵', members: ['grandparents_day'] },
  { label: 'Halloween', emoji: '🎃', members: ['halloween'] },
  { label: 'Thanksgiving', emoji: '🦃', members: ['thanksgiving'] },
  { label: 'Kwanzaa', emoji: '🕯️', members: ['kwanzaa'] },
];

export const ALL_HOLIDAY_IDS = HOLIDAY_PILLS.flatMap((pill) => pill.members);
export const visibleHolidayPillCount = (hidden: readonly string[]): number =>
  HOLIDAY_PILLS.filter((pill) => pill.members.some((id) => !hidden.includes(id))).length;
